import { Component } from '@angular/core';
import {
    DxDataGridComponent,
    DxFormComponent,
    DxTabsModule,
    DxTemplateDirective,
} from 'devextreme-angular';
import {
    DxiColumnComponent,
    DxiGroupItemComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoLoadPanelComponent,
    DxoPagerComponent,
    DxoGroupingComponent,
    DxoPagingComponent,
    DxoPositionComponent,
    DxoScrollingComponent,
    DxoSearchComponent,
    DxoSearchPanelComponent,
    DxoSelectionComponent,
    DxoSortingComponent,
    DxoToolbarComponent,
    DxoSummaryComponent,
} from 'devextreme-angular/ui/nested';
import { FilterPanelComponent } from '../../../components/library/filter-panel/filter-panel.component';
import {
    FilterConfig,
    GridPageComponent,
} from '../../common/grid-page.component';
import { YearToDateGridViewDto} from '@services';
import { CommonModule } from '@angular/common';
import { DATE_TIME_FORMAT } from 'src/app/shared/constants';
import { formatYearMonthKey } from 'src/app/shared/date-utils';
import { UserAvatarEmailComponent } from 'src/app/components/utils/user-avatar-email/user-avatar-email.component';
import { YearToDateScoreComponent } from './year-to-date-score/year-to-date-score.component';

@Component({
    selector: 'app-year-to-date',
    imports: [
        CommonModule,
        DxDataGridComponent,
        DxoScrollingComponent,
        DxoPagingComponent,
        DxoPagerComponent,
        DxoSummaryComponent,
        DxoGroupingComponent,
        DxoLoadPanelComponent,
        DxoPositionComponent,
        DxoSortingComponent,
        DxoSearchComponent,
        DxoHeaderFilterComponent,
        DxoFilterRowComponent,
        DxoColumnChooserComponent,
        DxoSearchPanelComponent,
        DxoSelectionComponent,
        DxoExportComponent,
        DxoToolbarComponent,
        DxiItemComponent,
        DxiColumnComponent,
        DxiGroupItemComponent,
        DxTemplateDirective,
        FilterPanelComponent,
        DxFormComponent,
        UserAvatarEmailComponent,
        YearToDateScoreComponent,
        DxTabsModule,
    ],
    templateUrl: './year-to-date.component.html',
})
export class YearToDateComponent extends GridPageComponent<YearToDateGridViewDto> {
    protected override exportName: string = 'Year to Date Report';
    protected offset: number = 150;
    public dateTimeFormat = DATE_TIME_FORMAT;

    tabs = [
        { text: 'My Score', id: 0 },
        { text: 'Data', id: 1 }
    ];

    selectedTab = this.tabs[0];

    dataSource = this.dataSources.yearToDate();

    lastModifiedByFilter = this.userNameOrEmailFilter('lastModifiedBy');
    createdByFilter = this.userNameOrEmailFilter('createdBy');

    protected override filterConfig: FilterConfig[] = [
        { field: 'date', op: '>=' },
        { field: 'looseCpPercentage', op: '=' },
        { field: 'layerPickPercentage', op: '=' },
        { field: 'looseCases', op: '=' },
        { field: 'fullCasesFert', op: '=' },
        { field: 'fullPalletsFertFpPickedOnly', op: '=' },
        { field: 'clubPackCasesPicked', op: '=' },
        { field: 'clubPackPalletsCpPickedOnly', op: '=' },
        { field: 'layerCases', op: '=' },
        { field: 'fertReceivedCases', op: '=' },
        { field: 'fertReceivedPallets', op: '=' },
        { field: 'clubPackReceivedCases', op: '=' },
        { field: 'clubPackReceivedPallets', op: '=' },
        { field: 'putsCasesFert', op: '=' },
        { field: 'outboundCases', op: '=' },
        { field: 'inboundCases', op: '=' },
        { field: 'throughput', op: '=' },
        { field: 'mpsPallets', op: '=' },
        { field: 'palletsReceivedAll', op: '=' },
        { field: 'fullPalletVolumePallets', op: '=' },
        { field: 'refill', op: '=' },
        { field: 'refillLayer', op: '=' },
        { field: 'totalRefill', op: '=' },
        { field: 'partialIns', op: '=' },
        { field: 'lastModified', op: '>=' },
        {
            field: 'lastModifiedBy.name',
            op: 'contains',
            customFilter: this.lastModifiedByFilter,
        },
        { field: 'lastModified', op: '>=' },
        {
            field: 'createdBy.name',
            op: 'contains',
            customFilter: this.createdByFilter,
        },
        { field: 'created', op: '>=' },
    ];

    constructor() {
        super();
        this.init(YearToDateGridViewDto);
    }

    onTabClick(e: any) {
        this.selectedTab = e.itemData;
    }

    formatDateKey = (cellInfo: any) => {
        return formatYearMonthKey(cellInfo?.value, cellInfo?.valueText ?? '');
    };
}
